module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container pd-50 products-wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "products-menu"
  }, [_c('h4', [_vm._v("\n                        Transportløsninger\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Læs om de forskellige transportløsninger vi tilbyder ved at klikke på nedenstående.\n                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      key: product.slug,
      attrs: {
        "to": {
          path: '/transportloesninger/' + product.slug
        },
        "tag": "a"
      }
    }, [_vm._v("\n                        " + _vm._s(product.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), [_c('router-view')]], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-page-title"
  }, [_c('h3', [_vm._v("\n            Transportløsninger\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68273503"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/products.vue
// module id = 268
// module chunks = 1